import { authFetch } from "./authProvider";

const SERVICE_URL = "wash-type-service/v2/organizations/:orgId";

export const getWashTypes = async (orgId) => {
  let url = SERVICE_URL.replace(":orgId", orgId) + "/wash-types";
  return await authFetch("get", url, {})
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
      return {};
    });
};
